import React from 'react';
export function CompetitionSchedule() {
  return <section className="py-24 bg-ink text-white text-center" data-id="element-817">
      <div className="max-w-3xl mx-auto px-4" data-id="element-818">
        <h2 className="text-4xl mb-6" data-id="element-819">Intensive Saturday Training</h2>
        <p className="text-xl text-gray-warm mb-8" data-id="element-820">
          Team Storm currently meets every Saturday from 7:00 PM to 9:00 PM for
          intensive sparring, conditioning, and tournament preparation.
        </p>
        <div className="inline-block border border-subtle-gray/30 bg-charcoal px-8 py-4 rounded-xl" data-id="element-821">
          <p className="font-bold text-lg uppercase tracking-wide text-storm-red" data-id="element-822">
            Advanced / Invitation Only
          </p>
        </div>
      </div>
    </section>;
}